import React, { useState, useEffect } from 'react';

const navbar = {
  items: [
    {
      text: "Features",
      link: "/#features"
    },
    {
      text: "Pricing",
      link: "/#pricing"
    },
    {
      text: "FAQ",
      link: "/#faq"
    },
    {
      text: "Blog",
      link: "/blog"
    }
  ],
  callToAction: {
    text: "Request beta access",
    link: "https://tally.so/r/mJvlzo"
  }
};

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isBlurred, setIsBlurred] = useState(false); // State to control blur

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // This useEffect will now control the body's overflow
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed'; // Prevents content from jumping on scrollbar removal
      document.body.style.width = '100%'; // Ensures content fills width when fixed
    } else {
      document.body.style.overflow = 'unset';
      document.body.style.position = 'unset';
      document.body.style.width = 'unset';
    }

    // Cleanup function to reset body styles when component unmounts or menu closes
    return () => {
      document.body.style.overflow = 'unset';
      document.body.style.position = 'unset';
      document.body.style.width = 'unset';
    };
  }, [isMenuOpen]); // Dependency array: re-run this effect when isMenuOpen changes

  useEffect(() => {
    const handleScroll = () => {
      // Check if the user has scrolled down beyond a certain point (e.g., 50px)
      if (window.scrollY > 50) {
        setIsBlurred(true);
      } else {
        setIsBlurred(false);
      }
    };

    // Add event listener when component mounts
    window.addEventListener('scroll', handleScroll);

    // Clean up event listener when component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array ensures this effect runs only once on mount and unmount

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 flex justify-between items-center px-8 py-4
        ${isBlurred ? 'bg-black bg-opacity-0 backdrop-blur-md' : 'bg-transparent'}
        transition-all duration-300 ease-in-out`}
    >
      {/* Logo */}
      <div className="text-white text-2xl lowercase">
        <a href="/">
          refray
        </a>
      </div>

      {/* Desktop Nav */}
      <div className="hidden xl:flex space-x-24 items-center text-lg justify-left">
        {navbar.items.map((item, i) => (
          <a
            key={i}
            href={item.link}
            className="text-white text-lg hover:opacity-80 transition"
          >
            {item.text}
          </a>
        ))}
        <button className="bg-primary text-white text-lg px-5 py-2.5 hover:opacity-80 transition">
          <a href={navbar.callToAction.link} className="text-white">
            {navbar.callToAction.text}
          </a>
        </button>
      </div>

      {/* Mobile Menu Button */}
      <div className="xl:hidden">
        <button
          onClick={toggleMenu}
          className={`text-white focus:outline-none focus:ring-2 focus:ring-white p-1.5 transition-opacity duration-300 ${isMenuOpen ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          <svg
            className="w-7 h-7"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
      </div>

      {/* Mobile Menu Panel */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-70 z-40 flex flex-col items-center justify-center space-y-8 xl:hidden transition-all duration-300 ease-out transform ${
          isMenuOpen ? "opacity-100 translate-y-0 backdrop-blur-md" : "opacity-0 -translate-y-full pointer-events-none"
        }`}
      >
        {/* Close Icon */}
        <button
          onClick={toggleMenu}
          className="absolute top-4 right-6 text-white focus:outline-none focus:ring-2 focus:ring-white p-2"
          aria-label="Close navigation menu"
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>

        {/* Mobile Nav Items */}
        {navbar.items.map((item, i) => (
          <a
            key={i}
            href={item.link}
            className="text-white text-3xl hover:opacity-80 transition"
            onClick={toggleMenu}
          >
            {item.text}
          </a>
        ))}

        <button className="bg-primary text-white text-2xl px-8 py-4 hover:bg-opacity-75 transition">
          <a
            href={navbar.callToAction.link}
            className="text-white"
            onClick={toggleMenu}
          >
            {navbar.callToAction.text}
          </a>
        </button>
      </div>
    </nav>
  );
}